import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as ArrowdownSVG } from 'assets/icons/arrow-down.svg';
import { getIn } from 'formik';
import { HintField, LabelField } from 'components';
import React, { useEffect, useRef, useState } from 'react';

const PaymentTypeSelect = ({
  formik,
  index,
  items,
  value,
  title,
  name,
  className,
  mandatory,
  titleStyle,
}) => {
  const [openTypeMenu, setOpenTypeMenu] = useState(false);

  const openLedgerMenuHandler = () => {
    setOpenTypeMenu(!openTypeMenu);
  };

  const menuRef = useRef();
  useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setOpenTypeMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  return (
    <>
      <LabelField
        htmlFor={name}
        title={title}
        labelClassName={className}
        mandatory={mandatory}
        style={titleStyle}
      />
      <div className="class_LedgersMenu">
        <button
          className="class_LedgersMenu_btn"
          onClick={openLedgerMenuHandler}
          ref={menuRef}
        >
          <div className="ledger_value">{value}</div>
          <ul className="ledgers_ul">
            {openTypeMenu &&
              items?.length > 0 &&
              items?.map((item) => {
                return (
                  <li
                    className="ledgers_li"
                    key={item}
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].type`, item);
                      if (item !== formik.values?.prices[index].type) {
                        formik.setFieldValue(`prices[${index}].ledger`, {});
                        formik.setFieldValue(`prices[${index}].subLedger`, {});
                        formik.setFieldValue(`prices[${index}].required_notes`, undefined);
                      }
                      if (item === 'No Payment Needed') {
                        formik.setFieldValue(`prices[${index}].is_splitted`, false);
                        formik.setFieldValue(`prices[${index}].split_duration`, undefined);
                        formik.setFieldValue(`prices[${index}].number_of_split`, undefined);
                        formik.setFieldValue(`prices[${index}].isInstallmentTransaction`, false);
                        formik.setFieldValue(`prices[${index}].installmentDetailsTransaction`, undefined);

                      }
                      if (item === "On Registration"){
                        formik.setFieldValue(`prices[${index}].is_splitted`, false);
                        formik.setFieldValue(`prices[${index}].split_duration`, undefined);
                        formik.setFieldValue(`prices[${index}].number_of_split`, undefined);
                      }
                      if (item === 'Optional') {
                        formik.setFieldValue(`prices[${index}].limitType`, 'checkbox');
                        formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
                      }
                    }}
                  >
                    {item}
                  </li>
                );
              })}
          </ul>
          {openTypeMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </button>
      </div>
      {getIn(formik?.touched, `prices[${index}].type`) && getIn(formik?.errors, `prices[${index}].type`) && (
        <HintField error={getIn(formik.errors, `prices[${index}].type`)} />
      )}
    </>
  );
};

export default PaymentTypeSelect;
